import { render } from "./ViewAssignPage.vue?vue&type=template&id=79d08479&ts=true"
import script from "./ViewAssignPage.vue?vue&type=script&lang=ts"
export * from "./ViewAssignPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__